define('modules/base/models/client.token.model',[
        'underscore',
        'backbone',
    'modules/base/models/token.model'
    ], function (_, Backbone, TokenModel) {
    var ClientTokenModel = TokenModel.extend({
        debugName: 'ClientTokenModel',
        serviceRoot:'prospector/v1/',
        requiresSpecifiedHost: true
    });
    return ClientTokenModel;
});


